import envVariables from "./envVariables";

const DEV_CONTAINER_NAME = "_9am";

const devContainer = {};

/**
 * Checks if the app runs in development mode and provided it does,
 * gives back a container `object` registered on the window object.
 * In case the app was not running in dev mode, this function will return `null`
 */
const getDevContainer = (): object | null => {
  if (!envVariables.DEV) {
    return null;
  }

  if (!Object.prototype.hasOwnProperty.call(window, DEV_CONTAINER_NAME)) {
    Object.defineProperty(window, DEV_CONTAINER_NAME, {
      get: () => devContainer,
      configurable: false,
      enumerable: true
    });
  }

  return devContainer;
};

/**
 * In development mode only, this function registers a new property on the
 * dev container object, which is accessible through the window object.
 * ("_9am", check DEV_CONTAINER_NAME)
 *
 * If not in dev mode, this function has no effect.
 */
export const addDevToolToWindow = (name: string, tool: unknown) => {
  const container = getDevContainer();
  if (!container) {
    return;
  }
  if (Object.keys(container).includes(name)) {
    // Message to developers, only in dev mode - no translation needed
    console.warn(
      `"${name}" property already exists on the "${DEV_CONTAINER_NAME}" container, you cannot override it.`
    );
    return;
  }
  Object.defineProperty(container, name, {
    get: () => tool,
    configurable: false,
    enumerable: true
  });
};
